module.exports = __webpack_public_path__ + "img/app-index.39f24895.png";